import { RefObject, useEffect } from 'react';

export const useClickOutside = <T extends HTMLElement = HTMLElement>(
    ref: RefObject<T>,
    callback: () => void,
) => {
    const handleClick = (e: MouseEvent | TouchEvent) => {
        if (ref.current && !ref.current.contains(e.target as Node)) {
            callback();
        }
    };

    useEffect(() => {
        document.addEventListener('mouseup', handleClick);
        document.addEventListener('touchend', handleClick);

        return () => {
            document.removeEventListener('mouseup', handleClick);
            document.removeEventListener('touchend', handleClick);
        };
    });
};
